import {useEffect, useState} from "react";
import {css} from "@panda/css";

import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import {PricesAddressComparison} from "../components/prices_address/PricesAddressComparison";
import {PricesAddressFAQ} from "../components/prices_address/PricesAddressFAQ";
import {PricesAddressHero} from "../components/prices_address/PricesAddressHero";
import {PricesAddressRoomsSection} from "../components/prices_address/PricesAddressRoomsSection";
import {PricesAddressSchemaDataset} from "../components/prices_address/PricesAddressSchemaDataset";
import {PricesAddressTrend} from "../components/prices_address/PricesAddressTrend";
import {PricesGlossary} from "../components/PricesGlossary";
import {PricesOffers} from "../components/PricesOffers";
import {PRICES_ADDRESS_GLOSSARY_TERMS} from "../constants/prices_address_glossary_terms";
import {getDefaultRoomsFilter} from "../constants/prices_address_rooms";
import {PRICES_SEARCH_COPY} from "../constants/prices_search";
import type {RoomsFilter} from "../constants/rcn_rooms_filter";
import {PricesViewType} from "../helpers/prices_view_type";
import {PRICES_ADDRESS_ANALYTICS_LOCATION} from "../tracking/prices_city_analytics";
import {trackPricesAddressRoomsFilterApplied} from "../tracking/track_prices_address_rooms_filter_applied";
import type {IPricesAddress} from "../types/IPricesAddress";
import {getAddressStatsRegion} from "../utils/get_address_stats_region";
import {getPricesAddressLink} from "../utils/get_prices_address_link";
import {getPricesRecentAddressId, updatePricesRecentSearchSubtitle} from "../utils/prices_search/prices_recent_searches_storage";

interface Props {
    cityRegion: IRegionReportPrice;
    address: IPricesAddress;
    availableRooms: RoomsFilter[];
}

export const PricesAddressLayout = (props: Props) => {
    const {cityRegion, address, availableRooms} = props;

    const [rooms, setRooms] = useState<RoomsFilter>(() => getDefaultRoomsFilter(availableRooms));
    const addressLabel = address.name;

    const statsRegion = getAddressStatsRegion(address);
    const addressUrl = getPricesAddressLink(address.rcnAddress);
    const recentAddressId = getPricesRecentAddressId(address.rcnAddress);
    const districtName = address.district?.name;

    // The prices search saves an address as "Adres · {miasto}"; only this page knows the district ("Adres · Mokotów").
    useEffect(() => {
        if (districtName) {
            updatePricesRecentSearchSubtitle(recentAddressId, `${PRICES_SEARCH_COPY.subtitles.address}${PRICES_SEARCH_COPY.subtitleSeparator}${districtName}`);
        }
    }, [recentAddressId, districtName]);

    const handleRoomsChange = (nextRooms: RoomsFilter) => {
        setRooms(nextRooms);
        scheduleTrackingTask(() => trackPricesAddressRoomsFilterApplied(nextRooms));
    };

    return (
        <div>
            <PricesBreadcrumbs
                type={PricesViewType.FLATS}
                region={cityRegion}
                districtName={districtName}
                address={{name: addressLabel, url: addressUrl}}
                className={breadcrumbsStyle}
            />

            <PricesAddressHero address={address} cityRegion={cityRegion} rooms={rooms} />

            <PricesAddressRoomsSection address={address} rooms={rooms} availableRooms={availableRooms} onRoomsChange={handleRoomsChange} />

            <PricesAddressComparison address={address} statsRegion={statsRegion} rooms={rooms} />

            <PricesAddressTrend address={address} initialRooms={rooms} availableRooms={availableRooms} />

            <PricesGlossary terms={PRICES_ADDRESS_GLOSSARY_TERMS} location={PRICES_ADDRESS_ANALYTICS_LOCATION} />

            <PricesOffers region={cityRegion} type={PricesViewType.FLATS} showDistrictFilter location={PRICES_ADDRESS_ANALYTICS_LOCATION} />

            <div className={faqWrapperStyle}>
                <PricesAddressFAQ address={address} rooms={rooms} />
            </div>

            <PricesAddressSchemaDataset address={address} rooms={rooms} />
        </div>
    );
};

const breadcrumbsStyle = css({
    backgroundColor: "var(--colors-white)",
    py: 2
});

const faqWrapperStyle = css({backgroundColor: "var(--colors-gray-200)"});
import {useEffect, useState} from "react";
import {css} from "@panda/css";

import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import {PricesAddressComparison} from "../components/prices_address/PricesAddressComparison";
import {PricesAddressFAQ} from "../components/prices_address/PricesAddressFAQ";
import {PricesAddressHero} from "../components/prices_address/PricesAddressHero";
import {PricesAddressRoomsSection} from "../components/prices_address/PricesAddressRoomsSection";
import {PricesAddressSchemaDataset} from "../components/prices_address/PricesAddressSchemaDataset";
import {PricesAddressTrend} from "../components/prices_address/PricesAddressTrend";
import {PricesGlossary} from "../components/PricesGlossary";
import {PricesOffers} from "../components/PricesOffers";
import {PRICES_ADDRESS_GLOSSARY_TERMS} from "../constants/prices_address_glossary_terms";
import {getDefaultRoomsFilter} from "../constants/prices_address_rooms";
import {PRICES_SEARCH_COPY} from "../constants/prices_search";
import type {RoomsFilter} from "../constants/rcn_rooms_filter";
import {PricesViewType} from "../helpers/prices_view_type";
import {PRICES_ADDRESS_ANALYTICS_LOCATION} from "../tracking/prices_city_analytics";
import {trackPricesAddressRoomsFilterApplied} from "../tracking/track_prices_address_rooms_filter_applied";
import type {IPricesAddress} from "../types/IPricesAddress";
import {getAddressStatsRegion} from "../utils/get_address_stats_region";
import {getPricesAddressLink} from "../utils/get_prices_address_link";
import {getPricesRecentAddressId, updatePricesRecentSearchSubtitle} from "../utils/prices_search/prices_recent_searches_storage";

interface Props {
    cityRegion: IRegionReportPrice;
    address: IPricesAddress;
    availableRooms: RoomsFilter[];
}

export const PricesAddressLayout = (props: Props) => {
    const {cityRegion, address, availableRooms} = props;

    const [rooms, setRooms] = useState<RoomsFilter>(() => getDefaultRoomsFilter(availableRooms));
    const addressLabel = address.name;

    const statsRegion = getAddressStatsRegion(address);
    const addressUrl = getPricesAddressLink(address.rcnAddress);
    const recentAddressId = getPricesRecentAddressId(address.rcnAddress);
    const districtName = address.district?.name;

    // The prices search saves an address as "Adres · {miasto}"; only this page knows the district ("Adres · Mokotów").
    useEffect(() => {
        if (districtName) {
            updatePricesRecentSearchSubtitle(recentAddressId, `${PRICES_SEARCH_COPY.subtitles.address}${PRICES_SEARCH_COPY.subtitleSeparator}${districtName}`);
        }
    }, [recentAddressId, districtName]);

    const handleRoomsChange = (nextRooms: RoomsFilter) => {
        setRooms(nextRooms);
        scheduleTrackingTask(() => trackPricesAddressRoomsFilterApplied(nextRooms));
    };

    return (
        <div>
            <PricesBreadcrumbs
                type={PricesViewType.FLATS}
                region={cityRegion}
                districtName={districtName}
                address={{name: addressLabel, url: addressUrl}}
                className={breadcrumbsStyle}
            />

            <PricesAddressHero address={address} cityRegion={cityRegion} rooms={rooms} />

            <PricesAddressRoomsSection address={address} rooms={rooms} availableRooms={availableRooms} onRoomsChange={handleRoomsChange} />

            <PricesAddressComparison address={address} statsRegion={statsRegion} rooms={rooms} />

            <PricesAddressTrend address={address} initialRooms={rooms} availableRooms={availableRooms} />

            <PricesGlossary terms={PRICES_ADDRESS_GLOSSARY_TERMS} location={PRICES_ADDRESS_ANALYTICS_LOCATION} />

            <PricesOffers region={cityRegion} type={PricesViewType.FLATS} showDistrictFilter location={PRICES_ADDRESS_ANALYTICS_LOCATION} />

            <div className={faqWrapperStyle}>
                <PricesAddressFAQ address={address} rooms={rooms} />
            </div>

            <PricesAddressSchemaDataset address={address} rooms={rooms} />
        </div>
    );
};

const breadcrumbsStyle = css({
    backgroundColor: "var(--colors-white)",
    py: 2
});

const faqWrapperStyle = css({backgroundColor: "var(--colors-gray-200)"});
